import { render, staticRenderFns } from "./CheckView.vue?vue&type=template&id=8673d942&scoped=true&"
import script from "./CheckView.vue?vue&type=script&lang=js&"
export * from "./CheckView.vue?vue&type=script&lang=js&"
import style0 from "./CheckView.vue?vue&type=style&index=0&id=8673d942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8673d942",
  null
  
)

export default component.exports